import axios from 'axios';

export async function verify(token: string): Promise<any>{

    return await axios.post(process.env.VUE_APP_CJ_API_URL +'/verify/'+token)
        .then(resp => {
            return {data: resp.data};
        })
        .catch(err => {
            console.log('error verify !',err);
            return {error : err};
        });
}
